import ngConfig from "@/config"
import store from '../store'
import { getToken, setToken, removeToken } from "@/utils/auth";
const msid = getToken('msid')


//海尔用户
export const userStaticMenus=(msid)=>{
  return [

  ]
}
//供应商
export const supplierStaticMenus=(msid)=>{
  return [

    {
      title: "管理信息",
      modules: [
        /* {name: "新供应商公示",href: `/srmoem/new-supplier-publicity?msid=${msid}`,icon: "resource-8.png"}, */
        ///srmoem/supplier/paperwork
        {name: "完善信息",href: `/srmoem/supplier/paperwork?msid=${msid}`,icon: "quota-1.png"},
        {name: "行业资质",href: `/srmoem/supplier/promise_ck?msid=${msid}`,icon: "supplier-1.png"},
        {name: "信用等级",href: `/srmoem/supplier/credit-rating-apply?msid=${msid}`,icon: "resource-7.png"},
        // {name: "供应商绩效",href: `/srmoem/new_purchaser_series/supplier_evaluation?msid=${msid}`,icon: "resource-5.png"},
      ],
    },
    {
      title: "需求抢单",
      modules: [
        {name: "公开需求",href: `/srmoem/supplier/demand-list?msid=${msid}`,icon: "needs-4.png"},
        {name: "定向需求",href: `/srmoem/supplier/demand-jz-list?msid=${msid}`,icon: "needs-5.png"},
        {name: "衍生需求",href: `/srmoem/supplier/ys-demand-list?msid=${msid}`,icon: "needs-6.png"},
        // {name: "结果公示",href: `/srmoem/supplier/demand-list?status=6?msid=${msid}`,icon: "resource-2.png"},
        {name:"图纸管理",href: `/dm/supplierDrawingManagement/supplierDashboard?msid=${msid}`,icon: "list-7.png"},
        {name: "样机公开需求列表",href: `/tbs/basicSupplier/capacity?msid=${msid}`,icon: "needs-12.png"},
        {name: "样机衍生需求列表",href: `/tbs/basicSupplier/looktype?msid=${msid}`,icon: "needs-13.png"},
      ],
    },
  ]
}
//海尔用户
export const haierUrl={
    /*lookForPrint:{
        treduce1Create: ngConfig.lookForPrint+`/lkp/create?msid=${msid}`,//生成指示书
        difference: ngConfig.lookForPrint+`/lkp/tSaleAfter?msid=${msid}`,//看单差异
    },*/
    quotaForResult:{
        BOMManagement:ngConfig.quotaForResult+`/quotaURL_3/treduce1/ManagementBOM?msid=${msid}`,//购销联动

        bom: ngConfig.quotaForResult+`/quotaURL/bom?msid=${msid}`,//看单差异
        tplus2: ngConfig.quotaForResult+`quotaURL_3/treduce2/rawBOM?msid=${msid}`,//原材料联动
        tplus13:ngConfig.quotaForResult+`/quotaURL/tplus13?msid=${msid}`,//日常数据管理
        biddingPrice: ngConfig.quotaForResult+`/invoice/inputView?msid=${msid}`,//招标结果管理 - 招标价格
    },
    system:{
      role:ngConfig.system+`/system/role?msid=${msid}`,//角色管理
      notice: ngConfig.system+`/system/notice?msid=${msid}`,//公告管理
      organization: ngConfig.system+`/system/organization?msid=${msid}`,//组织管理
      users:ngConfig.system+`/system/users?msid=${msid}`,//用户管理
    }
}
//供应商
export const supplierUrl={
    //看单打印
    /*lookForPrint:{
        treduce1Create: ngConfig.lookForPrint+`/lookPrint/treduce1/create?msid=${msid}`,//生成指示书
        difference: ngConfig.lookForPrint+`/lookPrint/difference/tSaleAfter?msid=${msid}`,//看单差异
    },*/
    quotaForResult:{
        tplus13:ngConfig.quotaForResult+`/quotaURL/tplus13`,//看单差异
    }
}



// WEBPACK FOOTER //
// ./src/modules/desktop/config/index.js